import { syncFloorPlanRooms } from './floor-plan-geometry.js';
const EXTERIOR_THICKNESS_CM = 20;
const INTERIOR_THICKNESS_CM = 12;
/**
 * Стены прямоугольного контура (без обхода — 4 независимых отрезка, как рисует
 * пользователь). Проёмы — по сторонам; offset от начала стороны: верх — слева
 * направо, низ — справа налево (c → d).
 */
function rectWalls(idPrefix, x, y, w, h, openings = {}) {
    const a = { x, y };
    const b = { x: x + w, y };
    const c = { x: x + w, y: y + h };
    const d = { x, y: y + h };
    const side = (k, p, q) => ({
        id: `${idPrefix}-${k}`,
        a: p,
        b: q,
        thickness: EXTERIOR_THICKNESS_CM,
        ...(openings[k] ? { openings: openings[k] } : {}),
    });
    return [side('t', a, b), side('r', b, c), side('b', c, d), side('l', d, a)];
}
const win = (id, offset, width) => ({ id, kind: 'WINDOW', offset, width });
const door = (id, offset, width = 80) => ({ id, kind: 'DOOR', offset, width });
function rectRoom(id, name, x, y, w, h) {
    return {
        id,
        name,
        points: [
            { x, y },
            { x: x + w, y },
            { x: x + w, y: y + h },
            { x, y: y + h },
        ],
    };
}
/** Студия: один прямоугольный объём без перегородок, ~20 м²: окно и входная дверь. */
function studio() {
    return {
        version: 1,
        walls: rectWalls('ext', 0, 0, 500, 400, { t: [win('win-1', 250, 160)], b: [door('entrance', 400, 90)] }),
        rooms: [rectRoom('room', 'Студия', 0, 0, 500, 400)],
    };
}
/** Однокомнатная: комната + кухня за одной внутренней перегородкой, ~26 м². */
function oneRoom() {
    const W = 620;
    const H = 420;
    const splitX = 400;
    return {
        version: 1,
        walls: [
            ...rectWalls('ext', 0, 0, W, H, {
                t: [win('win-room', 200, 140), win('win-kitchen', 510, 100)],
                b: [door('entrance', 110, 90)],
            }),
            { id: 'int-1', a: { x: splitX, y: 0 }, b: { x: splitX, y: H }, thickness: INTERIOR_THICKNESS_CM, openings: [door('door-room', 340)] },
        ],
        rooms: [
            rectRoom('room-1', 'Комната', 0, 0, splitX, H),
            rectRoom('room-2', 'Кухня', splitX, 0, W - splitX, H),
        ],
    };
}
/**
 * Двухкомнатная (евро), ~50 м²: кухня-гостиная во всю глубину со входом,
 * по бокам две спальни, санузел под первой; окна — на одном фасаде.
 */
function twoRoom() {
    const W = 880;
    const H = 620;
    const split1 = 300;
    const split2 = 620;
    const bathY = 420;
    return {
        version: 1,
        walls: [
            ...rectWalls('ext', 0, 0, W, H, {
                t: [win('win-1', 150, 120), win('win-2', 460, 160), win('win-3', 750, 120)],
                b: [door('entrance', W - 460, 90)],
            }),
            {
                id: 'int-1',
                a: { x: split1, y: 0 },
                b: { x: split1, y: H },
                thickness: INTERIOR_THICKNESS_CM,
                openings: [door('door-bed-1', 340), door('door-bath', 520, 70)],
            },
            { id: 'int-2', a: { x: split2, y: 0 }, b: { x: split2, y: H }, thickness: INTERIOR_THICKNESS_CM, openings: [door('door-bed-2', 520)] },
            { id: 'int-bath', a: { x: 0, y: bathY }, b: { x: split1, y: bathY }, thickness: INTERIOR_THICKNESS_CM },
        ],
        rooms: [
            rectRoom('room-1', 'Спальня', 0, 0, split1, bathY),
            rectRoom('room-2', 'Кухня-гостиная', split1, 0, split2 - split1, H),
            rectRoom('room-3', 'Спальня 2', split2, 0, W - split2, H),
            rectRoom('room-4', 'Санузел', 0, bathY, split1, H - bathY),
        ],
    };
}
/**
 * Прямоугольники комнат выше — только «ярлыки» с названиями: настоящие
 * контуры (по полу, за вычетом толщины стен) выводятся из стен тем же
 * алгоритмом, что и в редакторе, и наследуют названия по попаданию.
 */
function withDetectedRooms(data) {
    return { ...data, rooms: syncFloorPlanRooms(data, data.rooms, (n) => `Комната ${n}`) };
}
export const FLOOR_PLAN_TEMPLATES = [
    { id: 'studio', nameKey: 'plans.templateStudio', data: withDetectedRooms(studio()) },
    { id: 'one-room', nameKey: 'plans.templateOneRoom', data: withDetectedRooms(oneRoom()) },
    { id: 'two-room', nameKey: 'plans.templateTwoRoom', data: withDetectedRooms(twoRoom()) },
];
//# sourceMappingURL=floor-plan-templates.js.map